import { z } from "zod";

// Settings: workspace-wide data controls. Today, purging every prospect and
// analysis the user holds (email sender data, settings and the account stay).

export const usageSchema = z.object({
  prospects: z.number().int().nonnegative(),
  /** An estimate of what the user's lead data weighs. */
  storageBytes: z.number().int().nonnegative(),
});
export type Usage = z.infer<typeof usageSchema>;

export const purgeInputSchema = z.object({ confirm: z.literal(true) });
export const purgeResultSchema = z.object({ prospects: z.number().int(), analyses: z.number().int() });
export type PurgeResult = z.infer<typeof purgeResultSchema>;

export const emptyInputSchema = z.object({});
